export { CarCollections } from './lib/car-collections'
export { getStaticProps } from './lib/get-static-props'
